// extracted by mini-css-extract-plugin
export default {"root":"SelectList_root__jLtuP"};